// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExpandableTextBlock__text-dfa5a4,
.ExpandableTextBlock__show-more-a88123 {
  display: inline;
  font: inherit;
  letter-spacing: inherit;
}

.ExpandableTextBlock__text-dfa5a4 {
  word-break: break-word;
}

.ExpandableTextBlock__show-more-a88123 {
  cursor: pointer;
  color: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/ExpandableTextBlock/ExpandableTextBlock.styles.m.css"],"names":[],"mappings":"AAAA;;EAEE,eAAA;EACA,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,8BAAA;AACF","sourcesContent":[".text,\n.show-more {\n  display: inline;\n  font: inherit;\n  letter-spacing: inherit;\n}\n\n.text {\n  word-break: break-word;\n}\n\n.show-more {\n  cursor: pointer;\n  color: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `ExpandableTextBlock__text-dfa5a4`,
	"show-more": `ExpandableTextBlock__show-more-a88123`,
	"showMore": `ExpandableTextBlock__show-more-a88123`
};
module.exports = ___CSS_LOADER_EXPORT___;
